goog.provide("shadow.js.shim.module$src$svg$arrows$arrow_right_svg");
goog.provide("module$shadow_js_shim_module$src$svg$arrows$arrow_right_svg");
shadow.js.shim.module$src$svg$arrows$arrow_right_svg = shadow.js.nativeProvides["src/svg/arrows/arrow-right.svg"] = shadow$bridge("src/svg/arrows/arrow-right.svg");
module$shadow_js_shim_module$src$svg$arrows$arrow_right_svg.default = shadow.js.shim.module$src$svg$arrows$arrow_right_svg;
